/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export class User {
  logged = false;
  name = "";
  token = "";
  roles: string[] = [];
}
